import Vue from 'vue';

export interface BannerNotification {
    title: string;
    content: string;
    backgroundColor: string;
    textColor: string;
    isActive: boolean;
}

export const notificationBanner = new Vue({
    data() {
        return {
            banner: null as BannerNotification | null,
        };
    },
    methods: {
        show(notification: BannerNotification) {
            this.banner = {
                ...notification,
            };
        },

        hide() {
            this.banner = null;
        },
    },
});